/**
 * Review Popup JavaScript
 * Handles the review form popup functionality
 */

(function () {
  'use strict';

  const apiUrl = 'https://c9n4euwcbl.execute-api.ap-south-1.amazonaws.com/Prod/add-review';

  // Prevent multiple initializations
  if (window.reviewPopupInitialized) {
    console.log('Review popup already initialized');
    return;
  }
  window.reviewPopupInitialized = true;

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewPopup);
  } else {
    initReviewPopup();
  }

  function initReviewPopup() {
    // Popup controls
    const popupOverlay = document.getElementById('review-popup-overlay');
    const addReviewBtn = document.querySelector('.add-reviews-button');
    const closePopupBtn = document.getElementById('close-review-popup');
    const reviewForm = document.getElementById('review-form');

    // Check if elements exist
    if (!popupOverlay || !addReviewBtn || !closePopupBtn || !reviewForm) {
      console.warn('Review popup elements not found');
      return;
    }

    // Check if already initialized
    if (reviewForm.dataset.initialized === 'true') {
      console.log('Review form already initialized');
      return;
    }
    reviewForm.dataset.initialized = 'true';

    // Container elements
    const formContainer = document.getElementById('form-container');
    const loaderContainer = document.getElementById('loader-container');
    const successContainer = document.getElementById('success-container');
    const dismissBtn = document.getElementById('dismiss-success');

    // Rating elements
    const ratingStars = document.querySelectorAll('.rating-stars .star');
    const ratingInput = document.getElementById('aws-ratings');

    // Open popup
    addReviewBtn.addEventListener('click', () => {
      popupOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      // Reset to form view
      showFormView();
    });

    // Close popup
    function closePopup() {
      popupOverlay.classList.remove('active');
      document.body.style.overflow = '';
      // Reset form after closing
      setTimeout(() => {
        reviewForm.reset();
        updateStars(0);
        showFormView();
      }, 300);
    }

    closePopupBtn.addEventListener('click', closePopup);
    if (dismissBtn) {
      dismissBtn.addEventListener('click', closePopup);
    }

    // Close on overlay click
    popupOverlay.addEventListener('click', (e) => {
      if (e.target === popupOverlay) {
        closePopup();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && popupOverlay.classList.contains('active')) {
        closePopup();
      }
    });

    // View management functions
    function showFormView() {
      if (formContainer) formContainer.style.display = 'block';
      if (loaderContainer) loaderContainer.style.display = 'none';
      if (successContainer) successContainer.style.display = 'none';
    }

    function showLoaderView() {
      if (formContainer) formContainer.style.display = 'none';
      if (loaderContainer) loaderContainer.style.display = 'flex';
      if (successContainer) successContainer.style.display = 'none';
    }

    function showSuccessView() {
      if (formContainer) formContainer.style.display = 'none';
      if (loaderContainer) loaderContainer.style.display = 'none';
      if (successContainer) successContainer.style.display = 'flex';
    }

    // Rating stars interaction
    ratingStars.forEach((star) => {
      star.addEventListener('click', () => {
        const rating = star.getAttribute('data-rating');
        ratingInput.value = rating;
        updateStars(rating);
      });

      star.addEventListener('mouseenter', () => {
        const rating = star.getAttribute('data-rating');
        updateStars(rating);
      });
    });

    const ratingStarsContainer = document.querySelector('.rating-stars');
    if (ratingStarsContainer) {
      ratingStarsContainer.addEventListener('mouseleave', () => {
        updateStars(ratingInput.value || 0);
      });
    }

    function updateStars(rating) {
      ratingStars.forEach((star) => {
        const starRating = star.getAttribute('data-rating');
        if (starRating <= rating) {
          star.classList.add('active');
        } else {
          star.classList.remove('active');
        }
      });
    }

    // Show status message
    function showStatus(message, type = 'info') {
      const statusDiv = document.getElementById('status');
      if (statusDiv) {
        statusDiv.textContent = message;
        statusDiv.className = 'form-status ' + type;
      }
      console.log(`Status [${type}]:`, message);
    }

    // Submit form handler
    reviewForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      const name = document.getElementById('aws-name').value.trim();
      const email = document.getElementById('aws-email').value.trim();
      const ratings = parseFloat(document.getElementById('aws-ratings').value);
      const review_title = document.getElementById('aws-review-title').value.trim();
      const review_description = document.getElementById('aws-review-description').value.trim();
      const order_id = document.getElementById('aws-order-id').value.trim();

      // Validate required fields
      if (!name || !email || !ratings || !review_title || !review_description) {
        showStatus('Please fill in all required fields!', 'error');
        return;
      }

      // Validate rating range
      if (ratings < 1 || ratings > 5) {
        showStatus('Rating must be between 1 and 5!', 'error');
        return;
      }

      // Show loader
      showLoaderView();

      try {
        // Submit review
        const reviewData = {
          name,
          email,
          ratings,
          review_title,
          review_description,
          order_id: order_id || '',
        };

        console.log('Submitting review:', reviewData);

        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(reviewData),
        });

        const data = await response.json();
        console.log('Review submission response:', data);

        if (!response.ok) {
          throw new Error(data.message || 'Failed to submit review');
        }

        // Success! Show success view
        showSuccessView();
      } catch (err) {
        console.error('Full error:', err);
        // Show form again with error
        showFormView();
        showStatus('Error: ' + err.message, 'error');
      }
    });
  }
})();

